import { Component, OnInit } from '@angular/core';
import {MainService} from '../../../main/main.service';
import {MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import { animate, style, transition, trigger } from '@angular/animations';
import { BaseComponent } from '../../BaseComponent';
import { Dataset, Folder, FourDService, Transform } from '4d-mapper';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../app.service';
import { WMSUrlLayer, WMSUrlMeta, WMSUrlRequest } from '../../models';
import { ArrayStore, Store } from 'vasat';
import { FolderFileNode, TreeEvent, TreeNode, TreeNodeBuilder } from '@src/app/v2/commons/files/tree-events';
import { MapService } from '../../map.service';
import { filter, map } from 'rxjs/operators';
import { combineLatest, forkJoin, Observable } from 'rxjs';
import { CesiumMapService } from '@src/app/service/map-viewer.service';

const Cesium = (<any>window).Cesium;

interface LayerPair{
  meta:WMSUrlMeta
  layer:WMSUrlLayer
}


var buildLayerNode = (builder:TreeNodeBuilder, pair:LayerPair) => {
  var s = builder.fromStaticInfo(pair.layer.label,pair.layer.subLayers?pair.layer.subLayers.map(element => 
    buildLayerNode(builder,{meta:pair.meta,layer:element})
  ):[],false)

  s.ref = pair
  s.selectable = pair.layer.id != "null" && pair.layer.id != "!" && pair.layer.id != "?"
  return s
}



class FolderLayerNode extends FolderFileNode{
  loadChildren(){

    this.initChildListener();

    this._subs.push(this._builder.streams.fileEvents.pipe(filter(f => f.item.folder.id == this.f.id && this.hasChildren)).subscribe(f => {
        if(f.event == 'ADD'){
          console.log('## ADD CHILDREN', f, f.item );
            this.children.add(this._builder.fromFile(f.item))
        }
        else if(f.event == 'REMOVE'){
            this.children.values = this.children.values.filter(c => c.ref != f.item)
        }
    }))

    var folders = this.f.vasat.searchByObject(Folder)
        .equals('parent',this.f.id)
        .equals('active',true)
        .useCache(true)
        .sortBy('name')
        .queryObservable().pipe(map(r => 
            r.items.map(i => {
              var v = new FolderLayerNode(i,false,this.selectableFiles)
              v._builder = this._builder
              return v
            })
        ))
    var files = this.f.vasat.searchByObject(Dataset)
        .equals("folder",this.f.id)
        .equals("active",true)
        .useCache(true)
        .limit(100)
        .queryObservable().pipe(map(r => {
          var res = []
            r.items.filter(i => i['meta']).map(i =>  {
              
              var fakeLayer:WMSUrlLayer = <any>{
                label:i.name,
                id:'?',
                subLayers:i['meta'].layers
              }
              
              res.push(buildLayerNode(this._builder, {meta:i['meta'],layer:fakeLayer}))
                
            
            })
            return res;
        }))

    return combineLatest([folders,files]).pipe(map(([folderRes,fileRes]) => (<any[]>folderRes).concat(fileRes))).pipe(map(r => 
        this.children.values = r
    ))
  }
}



@Component({
  selector: 'dialog-upload-wms',
  templateUrl: './upload-wms.component.html',
  styleUrls: ['./upload-wms.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({transform: 'translateY(-100%)', opacity: 0, height:0 }),
        animate('0.2s 20ms ease-in-out', style({transform: 'translateY(0%)', opacity:1, height:'100%' }))
      ]),
      transition(':leave', [
        animate('0.3s 20ms ease-in-out', style({transform: 'translateY(-100%)', opacity:0, height:0 }))
      ])
    ])
  ]
})

export class UploadWMSComponent extends BaseComponent implements OnInit {

  exampleUrls:any[] = [
    { label:'WMS', url:'https://services.ga.gov.au/gis/services/Bathymetry_Topography/MapServer/WMSServer?request=GetCapabilities&service=WMS' }
  ];

  urlRequest:WMSUrlRequest

  itemsStore    = new ArrayStore(TreeEvent)
  currentItem:WMSUrlLayer

  // meta is the metadata object itself; it could be currentItem (as above), or a meta sub-object of a Dataset
  meta:any = null;

  selectedItems:Set<LayerPair> = new Set<LayerPair>()

  publicData:TreeNode
  urlData:TreeNode

  showImport:boolean = false;
  showAdvanced:boolean = false;
  showPreviewMap:boolean = false;

  constructor(
    public dialogRef: MatDialogRef<UploadWMSComponent> , public mainService: MainService,
    public route: ActivatedRoute, 
    public router: Router, 
    public fourD: FourDService, 
    snackBar: MatSnackBar, 
    dialog: MatDialog,
    private builder:TreeNodeBuilder,
    public mapService: MapService,
    public cesiumMapService: CesiumMapService,
    public service: AppService) {
      super(router, snackBar, dialog)
      this.reset()
      
      var pubFolderIds = Object.keys(service.permissions.can_i['library']).filter(k => service.permissions.can_i['library'][k] && k.startsWith('see_public_')).map(k => k.substring(11))

      //const these = ['public_australia','s_a37f609f-381c-4761-96eb-bb387a8edb5e'].join('|');
      const these = pubFolderIds.join('|');
      let theseFolders = [];

      var f = this.fourD.V.searchByObject(Folder).equals('uid',these).queryObservable().subscribe(r => {
        if(r.items.length){
          r.items.forEach(item => {
            let tmp = new FolderLayerNode(item, true,true)
            tmp['_builder'] = this.builder;
            this.itemsStore.add(tmp);
          });
        }
      })

  }

  ngOnInit() {
  }

  reset() {
    this.selectedItems = new Set<LayerPair>()
  
    //this.urlRequest = {url:"https://services.ga.gov.au/gis/services/AMSIS_Offshore_Minerals_Legacy/MapServer/WMSServer?request=GetCapabilities&service=WMS"}
    this.urlRequest = {url:""}
  }

  requestUrl() {
    this.loading = true
    


    this.service.apiDetectWmsUrl(this.urlRequest).subscribe(
      resA => {
        this.loading = false
        resA.forEach(res => {
          if(res.layers.length == 1)
          this.itemsStore.add(buildLayerNode(this.builder,{meta:res,layer:res.layers[0]}))
        else
          this.itemsStore.add(buildLayerNode(this.builder,{meta:res,layer:{
            id:'?',
            label:res.label,
            subLayers:res.layers
          }}))
        });
       
        
      }, err => {
        this.loading = false
        this.openSnackBarError(err.message)
      }
    )
  }

  download() {
    // TODO: For now just use the selected scene fodler
    if (this.mapService.scene && this.mapService.scene.folder) {
      var m = new Map<WMSUrlMeta,string[]>()

      this.selectedItems.forEach(a => {
        var existing = m.get(a.meta)
        if(existing)
          existing.push(a.layer.id)
        else {
            m.set(a.meta,[a.layer.id])
        }
      })

      // console.log(m)
      
      var obs:Observable<any>[] = []
      m.forEach( (v,k) => {
        // when the type is a reference, this isnt actually a remote streaming URL, its a local 4D resource
        // the 'id' is jsut the transfrom ID so add it to the scene like an old fashioned layer
        if(k.urlMethod == 'reference')
          obs.push(this.mapService.scene.addChildren([new Transform(this.service.V).set({id:parseInt(k.id) })])) 
        // oftherwise its a streaming URL
        else
          obs.push(this.service.apiCreateWmsLayers(this.mapService.scene.folder, {layerIds:v, meta:k}))
      })

      forkJoin(obs).subscribe(   res => {
        console.log("ENTER download res ",res)
        this.openSnackBarSuccess("Success")
        this.dialogRef.close()
      }, err => {
        console.log("ENTER download err ",err)
        this.openSnackBarSuccess("Error")
      })

    }
    
  }

  selectedNodeId:string = null;

  addClass(id:string, classy:string = 'selected' ) {
    let el = document.getElementById(id);
      if ( el ) {
        el.classList.add(classy);
      }
  }

  removeClass(id:string, classy:string = 'selected' ) {
    let el = document.getElementById(id);
      if ( el ) {
        el.classList.remove(classy);
      }
  }

  updateSelectedNode( incomingId:string = null ) {
    if ( this.selectedNodeId ) {
      this.removeClass(this.selectedNodeId);
    }
    if ( incomingId ) {
      this.selectedNodeId = incomingId;
      this.addClass(this.selectedNodeId);
    }
  }

  selectExample(url:string = '') {
    /* let el = <HTMLInputElement>document.getElementById('fdm-import-url');
    if ( el ) {
      el.value = url;
      el.focus();
    } */
    this.urlRequest.url = url;
  }

  onChange(event:TreeEvent) {

    console.log('## onChange ['+event.event+']', event );

    if (event.event == "selected") {

      this.currentItem = event.item.ref;
      this.meta = null;

      let ref = event.item.ref;

      if ( ref ) {

        if ( ref['layer'] ) {
          if ( ref['layer']['id'] ) {
            this.updateSelectedNode( 'file-' + ref['layer']['id'] );
          }
          this.meta = ref['layer'];
          if ( this.meta['bounds'] ) {
            let b = this.meta['bounds'];
            this.showPreviewMap = true;
            
            setTimeout ( () => {
              let test = this.cesiumMapService.getMap('mini');
              
              console.log('## onChange PREVIEW', test );
              if ( test && test.viewer ) {

                let el = document.getElementById('previewMap');
                let f = null;

                if ( el ) {
                  f = el.querySelector('.cesium-viewer-cesiumWidgetContainer');
                  if ( f ) {
                    f['style'].height = '200px';
                  }
                }
                console.log('## onChange PREVIEW EL', el, f );

                test.viewer.entities.removeAll();
                var bounds = test.viewer.entities.add({
                  name: "Bounds preview",
                  rectangle: {
                    coordinates: Cesium.Rectangle.fromDegrees( b.minX, b.minY, b.maxX, b.maxY),
                    material: Cesium.Color.YELLOW.withAlpha(0.3),
                  },
                });
                // dont fly the map if all the bounds are zero
                if(!(!b.minX && !b.minY && !b.maxX && !b.maxY))
                  test.viewer.flyTo(bounds,{ duration:1});
                test.viewer.scene.screenSpaceCameraController.enableRotate = false;
                test.viewer.scene.screenSpaceCameraController.enableTranslate = false;
                test.viewer.scene.screenSpaceCameraController.enableZoom = false;
                test.viewer.scene.screenSpaceCameraController.enableTilt = false;
                test.viewer.scene.screenSpaceCameraController.enableLook = false;
              }
            }, 300 );
          } else {
            this.showPreviewMap = false;
          }
          console.log('## onChange LAYER', this.selectedNodeId, ref['layer'] );
        } else {
          console.log('## onChange OTHER', event );
        }

      } else {
        console.log('## onChange NO_REF', event.item );
      }

    } else if (event.event == "checked") {
    
        // If checked add it to the list
        if (event.args) {
          this.selectedItems.add(event.item.ref)
        } else {
          // If unchecked remove it from list
          this.selectedItems.delete(event.item.ref)
        }
  
    }
    
  }

  toggleShowImport() {
    this.showImport = !this.showImport;
  }

  toggleShowAdvanced() {
    this.showAdvanced = !this.showAdvanced;
  }

  showDebug:boolean = false;
  toggleDebug() {
    this.showDebug = !this.showDebug;
    console.log('#toggle_debug',this.showDebug);
  }

}